export const getIDCardTypes = () => {
  return [
    {
      value: 0,
      label: 'آی دی کارت',
    },
    {
      value: 1,
      label: 'حکم',
    },
  ];
};
